module.exports = "<app-header></app-header>\n<app-notification [options]=\"notificationOptions\"></app-notification>\n<app-maps-search [options]=\"mapsSearchOptions\"></app-maps-search>\n<app-mastermap-warning></app-mastermap-warning>\n<app-demographic-report *ngIf=\"mapService.showDemographicReport && userService.loggedIn && userService.loggedInUser.canGetDemographics && userService.loggedInUser.canPullReports\"></app-demographic-report>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/marqetmap-app/marqetmap-app.component.html
// module id = ./src/app/components/marqetmap-app/marqetmap-app.component.html
// module chunks = main